import { render, staticRenderFns } from "./PortfolioCompanyItem.vue?vue&type=template&id=7648c2ca&scoped=true&"
import script from "./PortfolioCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./PortfolioCompanyItem.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioCompanyItem.vue?vue&type=style&index=0&id=7648c2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648c2ca",
  null
  
)

export default component.exports